import React, { useState } from 'react';

const GlobalPagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange, 
  recordsPerPage, 
  onPageSizeChange, 
  totalItems, 
  startIndex, 
  endIndex,
  label = 'items',
  size = 'normal', // 'small' for positions, 'normal' for others
  isLoading = false
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const options = [5, 10, 20];

  if (totalItems === 0) return null;


  const renderPageNumbers = () => {
    const pages = [];
    
    if (totalPages <= 5) {
      // Show all pages if 5 or fewer
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Always show first page
      pages.push(1);
      
      if (currentPage <= 2) {
        pages.push(2, 3);
        pages.push("...");
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 1) {
        pages.push("...");
        for (let i = totalPages - 2; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push("...");
        pages.push(currentPage - 1, currentPage, currentPage + 1);
        if (currentPage + 2 < totalPages) {
          pages.push("...");
        }
        pages.push(totalPages);
      }
    }
    
    return pages.map((page, index) => {
      if (page === "...") {
        return (
          <span
            key={`ellipsis-${index}`}
            className="px-1 py-1 text-sm text-muted"
            style={{ fontSize: '0.7rem' }}
          >
            …
          </span>
        );
      }
      
      const pageNum = page;
        const isSmall = size === 'small';
        return (
               <button
                 key={pageNum}
                 className={`btn ${isSmall ? '' : 'btn-sm'} ${currentPage === pageNum ? 'btn-primary' : 'btn-outline-primary'}`}
                 onClick={() => onPageChange(pageNum)}
                 disabled={isLoading}
                 style={{
                   minWidth: isSmall ? '20px' : '32px',
                   height: isSmall ? '20px' : '32px',
                   borderRadius: isSmall ? '3px' : '6px',
                   fontSize: isSmall ? '0.6rem' : '0.8rem',
                   fontWeight: '500',
                   border: currentPage === pageNum ? '1px solid #8e9aaf' : '1px solid #dee2e6',
                   backgroundColor: currentPage === pageNum ? '#8e9aaf' : 'transparent',
                   color: currentPage === pageNum ? '#ffffff' : '#8e9aaf',
                   boxShadow: currentPage === pageNum ? (isSmall ? '0 1px 2px rgba(13, 110, 253, 0.25)' : '0 2px 4px rgba(13, 110, 253, 0.25)') : 'none',
                   transition: 'all 0.2s ease-in-out',
                   padding: isSmall ? '0.1rem 0.2rem' : '0.3rem 0.6rem'
                 }}
          >
            {pageNum}
          </button>
        );
    });
  };

         const isSmall = size === 'small';
         
         return (
           <>
             <div className={`d-flex flex-column flex-md-row ${isSmall ? 'justify-content-center gap-1 mt-1 pt-1' : 'justify-content-between gap-2 mt-3 pt-2'} align-items-center border-top`} 
                  style={{ 
                    backgroundColor: '#f8f9fa', 
                    padding: isSmall ? '0.2rem 0.4rem' : '0.75rem', 
                    borderRadius: isSmall ? '4px' : '8px' 
                  }}>
             {/* Page Size Selector */}
             <div className="d-flex align-items-center gap-2">
               <label className={`text-muted ${isSmall ? '' : 'small'} mb-0 fw-medium`} style={{ fontSize: isSmall ? '0.6rem' : '0.8rem' }}>Show:</label>
               <div className="position-relative">
                 <button
                   type="button"
                   className="btn btn-outline-secondary border-0 shadow-sm d-flex align-items-center justify-content-between"
                   onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                   disabled={isLoading}
                   style={{ 
                     width: isSmall ? '50px' : '100px',
                     border: '2px solid #e9ecef',
                     borderRadius: isSmall ? '4px' : '8px',
                     fontSize: isSmall ? '0.6rem' : '0.8rem',
                     padding: isSmall ? '0.15rem 0.3rem' : '0.4rem 0.6rem',
                     height: isSmall ? '24px' : '32px',
                     backgroundColor: '#ffffff',
                     color: '#495057',
                     fontWeight: '500',
                     transition: 'all 0.2s ease-in-out',
                     cursor: 'pointer'
                   }}
                 >
                   <span>{isSmall ? recordsPerPage : `${recordsPerPage} `}</span>
                   <i className={`fas fa-chevron-${isDropdownOpen ? 'up' : 'down'}`} style={{ fontSize: '0.6rem' }}></i>
                 </button>
                 
                 {isDropdownOpen && (
                   <div 
                     className="position-absolute bg-white border shadow-sm rounded"
                     style={{
                       bottom: '100%',
                       left: 0,
                       right: 0,
                       zIndex: 1000,
                       border: '1px solid #dee2e6',
                       borderRadius: isSmall ? '4px' : '8px',
                       boxShadow: '0 -4px 6px rgba(0, 0, 0, 0.1)',
                       marginBottom: '4px'
                     }}
                   >
                     {options.map((option) => (
                       <div
                         key={option}
                         className="px-3 py-2 cursor-pointer dropdown-option"
                         style={{
                           fontSize: isSmall ? '0.6rem' : '0.8rem',
                           fontWeight: recordsPerPage === option ? '600' : '400',
                           backgroundColor: recordsPerPage === option ? '#f8f9fa' : '#ffffff',
                           color: '#495057',
                           cursor: 'pointer',
                           transition: 'all 0.2s ease-in-out',
                           border: '1px solid transparent'
                         }}
                         onClick={() => {
                          if (isLoading) return;
                           onPageSizeChange(option);
                           setIsDropdownOpen(false);
                         }}
                       >
                         {isSmall ? option : `${option} per page`}
                       </div>
                     ))}
                   </div>
                 )}
               </div>
             </div>

             {/* Page Info - Hidden for small size */}
             {!isSmall && (
               <div className="text-muted small fw-medium" style={{ fontSize: '0.8rem' }}>
                 Showing <span className="text-dark fw-bold">{startIndex}</span> - <span className="text-dark fw-bold">{endIndex}</span> of <span className="text-dark fw-bold">{totalItems}</span> {label}
               </div>
             )}

             {/* Pagination Controls */}
             <div className="d-flex align-items-center gap-1">
               {/* Prev Button */}
               <button
                 className={`btn ${isSmall ? 'btn-sm' : 'btn-sm'}`}
                 onClick={() => onPageChange(currentPage - 1)}
                 disabled={currentPage === 1 || isLoading}
                 style={{
                   borderRadius: isSmall ? '4px' : '6px',
                   fontSize: isSmall ? '0.6rem' : '0.8rem',
                   fontWeight: '600',
                   padding: isSmall ? '0.15rem 0.4rem' : '0.3rem 0.6rem',
                   border: currentPage === 1 ? '1px solid #dee2e6' : '1px solid #8e9aaf',
                   color: currentPage === 1 ? '#6c757d' : '#8e9aaf',
                   backgroundColor: currentPage === 1 ? '#f8f9fa' : 'transparent',
                   minWidth: isSmall ? '30px' : '60px',
                   height: isSmall ? '22px' : 'auto',
                   transition: 'all 0.2s ease',
                   display: 'flex',
                   alignItems: 'center',
                   justifyContent: 'center'
                 }}
               >
                 <i className="fas fa-chevron-left" style={{ fontSize: isSmall ? '0.5rem' : '0.7rem' }}></i>
                 {!isSmall && <span className="ms-1">Previous</span>}
               </button>

               {/* Page Numbers */}
               <div className="d-flex gap-1">
                 {renderPageNumbers()}
               </div>

               {/* Next Button */}
               <button
                 className={`btn ${isSmall ? 'btn-sm' : 'btn-sm'}`}
                 onClick={() => onPageChange(currentPage + 1)}
                 disabled={currentPage === totalPages || isLoading}
                 style={{
                   borderRadius: isSmall ? '4px' : '6px',
                   fontSize: isSmall ? '0.6rem' : '0.8rem',
                   fontWeight: '600',
                   padding: isSmall ? '0.15rem 0.4rem' : '0.3rem 0.6rem',
                   border: currentPage === totalPages ? '1px solid #dee2e6' : '1px solid #8e9aaf',
                   color: currentPage === totalPages ? '#6c757d' : '#8e9aaf',
                   backgroundColor: currentPage === totalPages ? '#f8f9fa' : 'transparent',
                   minWidth: isSmall ? '30px' : '60px',
                   height: isSmall ? '22px' : 'auto',
                   transition: 'all 0.2s ease',
                   display: 'flex',
                   alignItems: 'center',
                   justifyContent: 'center'
                 }}
               >
                 {!isSmall && <span className="me-1">Next</span>}
                 <i className="fas fa-chevron-right" style={{ fontSize: isSmall ? '0.5rem' : '0.7rem' }}></i>
               </button>
             </div>
    </div>
           </>
  );
};

export default GlobalPagination;
